import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  LinearProgress, 
  Box, 
  Grid 
} from '@mui/material';
import { 
  Memory, 
  Storage as StorageIcon,
  NetworkCheck 
} from '@mui/icons-material';
import PropTypes from 'prop-types';

const ResourceUsageCards = ({ currentUsage }) => {
  return (
    <Grid  mb={4} sx={{display:'flex', flexDirection:"row", width:'100%'}}>
      <Grid item xs={12} md={4} lg={4} sx={{width:"32%",mr:2}}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">CPU Usage</Typography>
              <Memory color="primary" />
            </Box>
            <Typography variant="h4" color="primary" fontWeight="bold">
              {currentUsage.cpu}%
            </Typography>
            <LinearProgress 
              variant="determinate" 
              value={currentUsage.cpu} 
              sx={{ mt: 2, mb: 1 }}
            />
            <Typography variant="caption" color="text.secondary">
              Average over last 5 minutes
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={4} lg={4} sx={{width:"32%",mr:2}}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">Memory Usage</Typography>
              <StorageIcon color="success" />
            </Box>
            <Typography variant="h4" color="success.main" fontWeight="bold">
              {currentUsage.memory}%
            </Typography>
            <LinearProgress 
              variant="determinate" 
              value={currentUsage.memory} 
              color="success"
              sx={{ mt: 2, mb: 1 }}
            />
            <Typography variant="caption" color="text.secondary">
              6.2 GB of 8 GB used
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={4} lg={4} sx={{width:"32%"}}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">Network I/O</Typography>
              <NetworkCheck color="secondary" />
            </Box>
            <Typography variant="h4" color="secondary.main" fontWeight="bold">
              {currentUsage.network}%
            </Typography>
            <LinearProgress 
              variant="determinate" 
              value={currentUsage.network} 
              color="secondary"
              sx={{ mt: 2, mb: 1 }}
            />
            <Typography variant="caption" color="text.secondary">
              125 MB/s throughput
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

ResourceUsageCards.propTypes = {
  currentUsage: PropTypes.shape({
    cpu: PropTypes.number.isRequired,
    memory: PropTypes.number.isRequired,
    network: PropTypes.number.isRequired,
  }).isRequired,
};

export default ResourceUsageCards;
